import {BaseApi} from './base-api';
import Vue from 'vue';

export class ImportApi extends BaseApi {
  static apiUri = 'imports';

  /** @return {Promise<EntityHttpResponse<ImportStayinStatus>>} */
  static getLastStayinImport () {
    return Vue.http.get(this.apiUri + '/stayin');
  }

  /** @return {Promise<EntityHttpResponse<ImportStayinResult>>} */
  static doStayinImport (force) {
    return Vue.http.post(this.apiUri + '/stayin', null, {params: {force: force}, timeout: 60 * 1000});
  }
}
